import { OperationItem } from "../utils"

export const getOperationItemIsTransferred = (
  operationItem: OperationItem,
  operationOwnerId: string | undefined,
  isReinforcedTraceability: boolean,
  currentUserId: string
) => {
  const contact = operationItem.operation?.contact
  return (
    (contact &&
      ((contact.userId !== operationOwnerId &&
        contact.userId !== currentUserId) ||
        isReinforcedTraceability)) ||
    !operationItem.isInInformationRequest
  )
}
